import React from 'react'
import IconSVG from 'svg-inline-react'

const ConnectedIcon = () => (
  <IconSVG
    className="connected-icon"
    src={require('!svg-inline?removeTags=true!images/svg/green-check-circle.svg')}
  />
  )

export default ConnectedIcon



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/ConnectedIcon.js